import { render, staticRenderFns } from "./TreeEditRatificaciones.vue?vue&type=template&id=1ee9e4de&scoped=true"
import script from "./TreeEditRatificaciones.vue?vue&type=script&lang=js"
export * from "./TreeEditRatificaciones.vue?vue&type=script&lang=js"
import style0 from "./TreeEditRatificaciones.vue?vue&type=style&index=0&id=1ee9e4de&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee9e4de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ee9e4de')) {
      api.createRecord('1ee9e4de', component.options)
    } else {
      api.reload('1ee9e4de', component.options)
    }
    module.hot.accept("./TreeEditRatificaciones.vue?vue&type=template&id=1ee9e4de&scoped=true", function () {
      api.rerender('1ee9e4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/TreeEditRatificaciones.vue"
export default component.exports